module.exports = __webpack_public_path__ + "static/img/117.78.39.56.6ee3e2ef.png";